import { Icon } from 'components/ui/atoms/icons';
import { BriefCase } from 'components/ui/atoms/icons/BriefCase';
import { GrowthChart } from 'components/ui/atoms/icons/GrowthChart';

const careerCardContent = {
  'computer science': {
    priority: 0,
    sectionTitle: 'Outlook for computer science careers',
    stats: {
      salary: {
        title: 'Avg. 2024 salary',
        value: '$140,910',
        icon: (
          <Icon
            type="money-outline"
            svgProps={{
              style: { width: 48, height: 48 },
              'aria-label': 'dollar sign icon',
            }}
          />
        ),
      },
      jobs: {
        title: 'Est. job openings',
        value: '3,200',
        icon: <BriefCase svgProps={{ width: '48px', height: '48px' }} />,
      },
      growth: {
        title: 'Est. career growth',
        value: '20%',
        icon: <GrowthChart svgProps={{ width: '48px', height: '48px' }} />,
      },
    },
  },
  'business & management': {
    priority: 1,
    sectionTitle: 'Outlook for business and management careers',
    stats: {
      salary: {
        title: 'Avg. 2024 salary',
        value: '$80,920',
        icon: (
          <Icon
            type="money-outline"
            svgProps={{
              style: { width: 48, height: 48 },
              'aria-label': 'dollar sign icon',
            }}
          />
        ),
      },
      jobs: {
        title: 'Est. job openings',
        value: '942,500',
        icon: <BriefCase svgProps={{ width: '48px', height: '48px' }} />,
      },
      growth: {
        title: 'edX courses taken',
        value: '22M+',
        icon: (
          <Icon
            type="people"
            svgProps={{
              style: { width: 48, height: 48 },
              'aria-label': 'people icon',
            }}
          />
        ),
      },
    },
  },
  'social sciences': {
    priority: 2,
    sectionTitle: 'Outlook for social science careers',
    stats: {
      salary: {
        title: 'Avg. 2025 salary',
        value: '$75,000',
        icon: (
          <Icon
            type="money-outline"
            svgProps={{
              style: { width: 48, height: 48 },
              'aria-label': 'dollar sign icon',
            }}
          />
        ),
      },
      jobs: {
        title: 'Est. job openings',
        value: '5,226,990',
        icon: <BriefCase svgProps={{ width: '48px', height: '48px' }} />,
      },
      growth: {
        title: 'edX courses taken',
        value: '6M+',
        icon: (
          <Icon
            type="people"
            svgProps={{
              style: { width: 48, height: 48 },
              'aria-label': 'people icon',
            }}
          />
        ),
      },
    },
  },
  'data analysis & statistics': {
    priority: 3,
    sectionTitle: 'Outlook for data science careers',
    stats: {
      salary: {
        title: 'Avg. 2024 salary',
        value: '$112,590',
        icon: (
          <Icon
            type="money-outline"
            svgProps={{
              style: { width: 48, height: 48 },
              'aria-label': 'dollar sign icon',
            }}
          />
        ),
      },
      jobs: {
        title: 'Est. job openings',
        value: '23,400',
        icon: <BriefCase svgProps={{ width: '48px', height: '48px' }} />,
      },
      growth: {
        title: 'Est. career growth',
        value: '34%',
        icon: <GrowthChart svgProps={{ width: '48px', height: '48px' }} />,
      },
    },
  },
  humanities: {
    priority: 4,
    sectionTitle: 'Outlook for humanities careers',
    stats: {
      salary: {
        title: 'Avg. 2025 salary',
        value: '$112,590',
        icon: (
          <Icon
            type="money-outline"
            svgProps={{
              style: { width: 48, height: 48 },
              'aria-label': 'dollar sign icon',
            }}
          />
        ),
      },
      jobs: {
        title: 'Jobs filled in 2025',
        value: '790,310',
        icon: <BriefCase svgProps={{ width: '48px', height: '48px' }} />,
      },
      growth: {
        title: 'edX courses taken',
        value: '10M+',
        icon: (
          <Icon
            type="people"
            svgProps={{
              style: { width: 48, height: 48 },
              'aria-label': 'people icon',
            }}
          />
        ),
      },
    },
  },
};

export { careerCardContent };
